var map = {
	"./Deliveroo.png": "OYOD",
	"./Deliveroo.svg": "mIx6",
	"./Glovo.png": "tU6x",
	"./Glovo.svg": "gCK0",
	"./Just Eat.png": "OciF",
	"./Just Eat.svg": "4HAL",
	"./NumiResto.png": "31An",
	"./Uber Eats.png": "jl1D",
	"./Uber Eats.svg": "t3Wm",
	"./burguer-color.gif": "GSoC",
	"./ca.svg": "TKvO",
	"./de.svg": "hkB+",
	"./deliveroo_gestion.png": "HeOp",
	"./deliveroo_gestion.svg": "o4Kn",
	"./en.svg": "tc7e",
	"./es.svg": "FxNG",
	"./eu.svg": "tnaW",
	"./fr.svg": "w3lL",
	"./globe.svg": "rKBF",
	"./glovo_gestion.png": "uZqR",
	"./glovo_gestion.svg": "OHdp",
	"./it.svg": "OMyd",
	"./justeat_gestion.png": "00Sx",
	"./justeat_gestion.svg": "RI3b",
	"./numier-blue-background.png": "1gkc",
	"./pizza.gif": "NYcK",
	"./plato.gif": "rBcd",
	"./pt.svg": "By/3",
	"./sinqro.png": "wkim",
	"./stars.svg": "jOi1",
	"./ubereats_gestion.png": "Xfsw",
	"./ubereats_gestion.svg": "J5Oh",
	"./wok.gif": "ITYY"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "czpq";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/.*$
// module id = czpq
// module chunks = 4